import { motion } from "framer-motion";
import Label from "@/components/Label";

// Editorial page header for interior pages
export default function PageHero({ script, title, subtitle, align = "left" }) {
  const alignCls = align === "center" ? "items-center text-center mx-auto" : "items-start";
  return (
    <section className="border-b border-black/10">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-24">
        <div className={`flex flex-col ${alignCls} max-w-3xl`}>
          {script && (
            <motion.div
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="mb-5"
            >
              <Label>{script}</Label>
            </motion.div>
          )}
          <h1 className="mt-1 font-serif-display font-light tracking-tighter leading-[0.95] text-[#050505] text-5xl sm:text-6xl md:text-7xl overflow-hidden">
            <motion.span
              className="block"
              initial={{ y: "110%" }}
              animate={{ y: "0%" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
            >
              {title}
            </motion.span>
          </h1>
          {subtitle && (
            <motion.p
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.35 }}
              className={`mt-6 text-base md:text-lg leading-relaxed text-[#3d3d3d] ${
                align === "center" ? "max-w-xl" : "max-w-2xl"
              }`}
            >
              {subtitle}
            </motion.p>
          )}
        </div>
      </div>
    </section>
  );
}
